<template>
  <div class="collaborator-list-item">
    <div class="collaborator-info">
      <FriedAvatar :name="user.fullName" :thumb-url="user.thumbUrl" />
      <div>
        <FriedH4>{{ user.fullName }}</FriedH4>
        <FriedParagraph :size="ParagraphSize.Small">{{ user.email }}</FriedParagraph>
      </div>
    </div>
    <div class="collaborator-actions">
      <FriedIconButton
        v-if="canEdit || currentUser.id === user.id"
        v-tooltip="{
          content: t('dr_remove_collaborator_tooltip'),
          distance: 8,
          delay: { show: 300, hide: 100 },
        }"
        :data-external="`remove-collaborator-${user.id}-button`"
        @click="$emit('remove', user.id)"
      >
        <FriedIcon icon="close-circle" />
      </FriedIconButton>
    </div>
  </div>
</template>
<script lang="ts">
import type { PropType } from 'vue';
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import { ParagraphSize, Placement } from '@getaccept/fried-tofu';
import type { Participant } from '@getaccept/dsr-shared';
import { ParticipantRole } from '../types/enums/participant-role';
import type { User } from '../../users/types/user';

export default defineComponent({
  props: {
    user: {
      type: Object as PropType<User>,
      default: () => ({}) as User,
    },
    currentUser: {
      type: Object as PropType<Participant>,
      default: () => ({}),
    },
    canEdit: { type: Boolean },
  },
  emits: ['remove'],
  setup() {
    const { t } = useI18n();

    return {
      t,
      ParagraphSize,
      ParticipantRole,
      Placement,
    };
  },
});
</script>
<style lang="scss" scoped>
.collaborator-list-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-50) 0;

  .collaborator-info,
  .collaborator-actions {
    display: flex;
    align-items: center;
    gap: var(--spacing-50);
  }
}
</style>
